import "leaflet-draw";
import { MenuItem, Select, Typography, Button, Divider, Tooltip as MUIToolTip, IconButton } from "@mui/material";
import "leaflet/dist/leaflet.css";
import "./StarlinkMaps.css";
import _ from "lodash";
import { useHistory, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { YYYYMMDD_HHmmss } from "../../utils/constants";
import moment from "moment";
import SettingsIcon from '@mui/icons-material/Settings';
import { getSubscriptionForAccount } from "../StarlinkAdmin/slice";
import Tooltip from '@mui/material/Tooltip';
import {  getDataFromLocalStorageParsed, getDecodeURI, getEncodedURI, } from "../../utils/util";

const StarlinkMapPopup = (props) => {
    const { selectedServiceLineLocal, open, handleOverlayInteraction, handleOverlayInteractionEnd, setSelectedServiceLine, setMapClick, map, setOpen, handleChangeTerminal, selectedTerminal,
        starlinkMapTelemetryLocal, handleInsightsClick, setEditActionsPopup, setDataForPopup, serviceLinesForAdmin, handleConvert, convertSeconds, handleSiteClick, getSubscriptionForAccount,
        location, history
    } = props;
    const onlyStarlinkUser = getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.starlinkOnlyUser;
    const formatNumber = (value, unit = '', decimals = 2) => typeof value === 'number' ? `${value.toFixed(decimals)}${unit}` : 'N/A';
    const formatPercent = value => typeof value === 'number' ? `${(value * 100).toFixed(2)} %` : '0.00 %';
    const formatSeconds = value =>  typeof value === 'number' ? convertSeconds(value.toFixed(0)) : 'N/A';

    const telemetry = starlinkMapTelemetryLocal?.[0];

    const terminalRows = telemetry ? [
        { label: 'Terminal ID', value: telemetry?.device_id || 'N/A' },
        { label: 'Obstruction', value: formatNumber(telemetry?.obstruction_percent_time, ' %') },
        { label: 'Downlink', value: formatNumber(telemetry?.downlink_throughput, ' Mbps') },
        { label: 'Uplink', value: formatNumber(telemetry?.uplink_throughput, ' Mbps') },
        { label: 'Signal Quality', value: formatPercent(telemetry?.signal_quality) },
        {
            label: 'Ping Drop Rate',
            value: typeof telemetry?.ping_drop_rate_avg === 'number'
                ? `${(telemetry.ping_drop_rate_avg * 100).toFixed(2)} %`
                : 'N/A'
        },
        { label: 'Latency', value: formatNumber(telemetry?.ping_latency_ms_avg, ' ms') },
        { label: 'Uptime', value: formatSeconds(telemetry?.uptime) },
        {
            label: 'Last Online',
            value: telemetry?.last_online
                ? moment(telemetry.last_online).format(YYYYMMDD_HHmmss)
                : 'N/A'
        },
        {
            label: 'Coordinates',
            value: telemetry?.lati && telemetry?.long
                ? handleConvert(telemetry.lati, telemetry.long)
                : 'N/A'
        }
    ] : [];



    return (
        <>
            <div className="overlay-container"
                onMouseEnter={handleOverlayInteraction}
                onMouseLeave={handleOverlayInteractionEnd}
            >
                <div className="overlay-header">
                    <Typography
                        variant="h6"
                        className="titleTypo"
                        sx={{
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            maxWidth: "250px",
                        }}
                    >
                        {
                            selectedServiceLineLocal?.accountDpName && selectedServiceLineLocal?.dpName
                                ? `${selectedServiceLineLocal.accountDpName} / ${selectedServiceLineLocal.dpName}`
                                : selectedServiceLineLocal?.accountDpName || selectedServiceLineLocal?.dpName || ""
                        }
                    </Typography>

                    <button
                        className="cancel-button"
                        onClick={() => {
                            setSelectedServiceLine(null);
                            setMapClick('empty');
                            setOpen(!open);
                            if (map) {
                                map.setView([35, -35], 3);
                                map.dragging.enable();
                            }
                            const params = getDecodeURI(location.search);
                            params.serviceLineAccess = "All";
                            delete params.search;
                            history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
                        }}
                    >
                        ✕
                    </button>
                </div>

                <Typography variant="h6" className="titleTypo"
                    sx={{
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        maxWidth: "350px",
                    }}>
                    {selectedServiceLineLocal?.nickname || "NA"}
                </Typography>
                <Divider style={{ backgroundColor: '#ccc', height: '1px', width: '100%' }} />
                <Typography variant="h6" className="titleTypo">
                    SL Number: {selectedServiceLineLocal?.serviceLineNumber || ''}
                </Typography>
                <Typography variant="h6" className="titleTypo">
                    Plan: {selectedServiceLineLocal?.servicePlan ? selectedServiceLineLocal?.servicePlan?.length > 25
                        ? `${selectedServiceLineLocal?.servicePlan.slice(0, 25)}.. (${Number(selectedServiceLineLocal?.billingUsagePercent ? selectedServiceLineLocal?.billingUsagePercent : 0.00)?.toFixed(1)}%)`
                        : `${selectedServiceLineLocal?.servicePlan} (${Number(selectedServiceLineLocal?.billingUsagePercent ? selectedServiceLineLocal?.billingUsagePercent : 0.00)?.toFixed(1)}%)` : "NA"}

                </Typography>
                <div className="usage-container">
                    <div className="usage-header">
                        <span>Usage</span>
                        <span className="usage-value">
                            {parseFloat(selectedServiceLineLocal?.usageGB || 0).toFixed(0)} GB
                        </span>
                    </div>

                    {[
                        { label: "Local Priority", key: "localPriority" },
                        { label: "Global Priority", key: "globalPriority" },
                        { label: "Mobile Priority", key: "mobilePriorityData" },
                        { label: "Other data", key: "otherData" },
                        { label: "Legacy Plans", key: "legacyPlansData" }
                    ].map(item => (
                        <div key={item.key} className="usage-item-strlinkMap">
                            <span className="usage-label">• {item.label}</span>
                            <span className="usage-amount">
                                {parseFloat(selectedServiceLineLocal?.[item.key] || 0).toFixed(0)} GB
                            </span>
                        </div>
                    ))}
                </div>

                <div className="terminal-container">
                    <div className="terminal-item">
                        {selectedServiceLineLocal?.userTerminals && selectedServiceLineLocal?.userTerminals !== '' ?
                            JSON.parse(selectedServiceLineLocal?.userTerminals) && JSON.parse(selectedServiceLineLocal?.userTerminals).length > 1 ?
                                <Select
                                    fullWidth
                                    size="small"
                                    inputProps={{
                                        MenuProps: {
                                            MenuListProps: {
                                                sx: {
                                                    backgroundColor: '#333',
                                                    color: 'white',
                                                }
                                            }
                                        }
                                    }}
                                    value={selectedTerminal || ""}
                                    className="strMaps-custom-select strMap-sl-dropdown"
                                    onChange={(e) => handleChangeTerminal(e.target.value)}
                                    displayEmpty
                                    renderValue={(selected) =>
                                        selected
                                            ? `${selected?.kitSerialNumber}`
                                            : "Select Terminal"
                                    }
                                >
                                    {selectedServiceLineLocal?.userTerminals &&
                                        JSON.parse(selectedServiceLineLocal?.userTerminals)?.map((terminal) => (
                                            <MenuItem key={terminal.userTerminalId} value={terminal}>
                                                {terminal.kitSerialNumber}
                                            </MenuItem>
                                        ))}
                                </Select>
                                :
                                <div style={{ width: "100%" }}>
                                    <Typography variant="h6" className="titleTypo">
                                        {JSON.parse(selectedServiceLineLocal?.userTerminals)[0]?.kitSerialNumber || "User Terminal Details"}
                                    </Typography>
                                    <Divider style={{ backgroundColor: '#ccc', height: '1px', width: '100%' }} />
                                </div>
                            : null}
                    </div>

                    <>
                        {terminalRows.map(({ label, value }) => (
                            <div key={label} className="terminal-item">
                                <span className="terminal-label">{label}</span>
                                {value !== 'N/A' ? (
                                <Tooltip title="Current data" arrow>
                                    <span className="terminal-value">{value}</span>
                                </Tooltip>
                                ) : (
                                <span className="terminal-value">{value}</span>
                                )}
                            </div>
                        ))}

                        {(telemetry?.ipv4_str || telemetry?.ipv6_ue_str || telemetry?.ipv6_cpe_str) && (
                            <>
                                <div className="terminal-item">
                                    <span className="terminal-label">Public IP</span>
                                    <span className="terminal-value">{telemetry?.ipv4_str}</span>
                                </div>

                                {[telemetry?.ipv6_ue_str, telemetry?.ipv6_cpe_str].map(
                                    ip =>
                                        ip && (
                                            <div key={ip} className="terminal-item">
                                                <span className="terminal-label" />
                                                <span className="terminal-value">{ip}</span>
                                            </div>
                                        )
                                )}
                            </>
                        )}

                        <Divider className="terminal-divider" />
                    </>


                </div>

                <div className="d-flex str-justify str-mt-0">
                    {selectedServiceLineLocal?.k4SiteName &&
                        <MUIToolTip title={selectedServiceLineLocal?.k4SiteName} arrow  >
                            <Button size="small" variant="contained" disabled={onlyStarlinkUser} className='starlink--button_contained--primary' onClick={() => { handleSiteClick({ location_id: selectedServiceLineLocal?.k4SiteId, site: selectedServiceLineLocal?.k4SiteName }) }} >Site</Button>
                        </MUIToolTip>}
                    <Button size="small" variant="contained" className='starlink--button_contained--primary'
                        disabled={selectedServiceLineLocal ? selectedServiceLineLocal?.userTerminals ? selectedServiceLineLocal?.userTerminals === "" : true : true}
                        onClick={() => {
                            handleInsightsClick(selectedServiceLineLocal)
                        }} >Insights</Button>

                    <Button size="small" variant="contained" className='starlink--button_contained--primary'
                        // disabled={_.isEmpty(serviceLinesForAdmin )}
                        onClick={() => {
                            setEditActionsPopup(true)
                            setDataForPopup(serviceLinesForAdmin[0])
                            getSubscriptionForAccount({ dpIds: serviceLinesForAdmin[0]?.accountDpId })
                        }} >
                        <IconButton
                            className="strMap-SettingsIcon"
                            size='small'>
                            <SettingsIcon />
                        </IconButton>
                    </Button>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({});

export default withRouter(
    connect(mapStateToProps, {
        getSubscriptionForAccount
    })(StarlinkMapPopup)
);